export default __webpack_public_path__ + "static/media/NFO_PostLogin_Consumption_Fund_Hero_desktop.ce675736.png";